import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";

export default function CTASection() {
  return (
    <section className="relative bg-brand-ink text-white py-14 md:py-20 overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 bg-grid-dark opacity-60 pointer-events-none" />
      <div className="absolute -right-40 -top-40 w-[500px] h-[500px] bg-brand-cta/10 rounded-full blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <div className="overline" style={{ color: "#FF4500" }}>Démarrez votre projet IA</div>
            <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
              Parlez de votre projet à un <span className="text-brand-cta">conseiller pédagogique.</span>
            </h2>
            <p className="mt-4 text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Devis personnalisé sous 24 h. Programme adapté à votre métier. Financement CPF et OPCO accompagné de A à Z.
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-3">
            <Link to="/contact" className="btn-cta justify-center" data-testid="cta-contact-button">
              Demander un devis
              <ArrowUpRight className="w-5 h-5" />
            </Link>
            <a href="tel:+33626345597" className="btn-ghost-light justify-center" data-testid="cta-phone-button">
              <Phone className="w-4 h-4" />
              06 26 34 55 97
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
